   <div class="container mx-auto p-4">
      <h2 class="text-2xl mb-4">Upload Images to Azure Blob Storage</h2>
      <input
        type="file"
        webkitdirectory
        multiple
        (change)="onFolderSelected($event)"
        class="mb-4"
      />
      <div *ngIf="uploadProgress.length > 0" class="mt-4">
        <h3 class="text-lg">Upload Progress</h3>
        <div *ngFor="let progress of uploadProgress" class="mb-2">
          {{ progress.fileName }}: {{ progress.progress }}%
        </div>
      </div>
      <button
        (click)="uploadFiles()"
        [disabled]="!selectedFiles.length || uploading"
        class="bg-blue-500 text-white px-4 py-2 rounded disabled:bg-gray-400"
      >
        {{ uploading ? 'Uploading...' : 'Upload Files' }}
      </button>
    </div>